import {darken, generateThemes, lighten} from '@nfq/colors';

import type {GetThemeType} from '@nfq/colors';

const SharedColors = {
    /** ![#D5D6D6](https://dummyimage.com/12/D5D6D6/D5D6D6.png) `#D5D6D6`. */
    acePrimary: '#D5D6D6',
    /** ![#B30911](https://dummyimage.com/12/B30911/B30911.png) `#B30911`. */
    aceSecondary: '#B30911',
    /** ![#2B73FF](https://dummyimage.com/12/2B73FF/2B73FF.png) `#2B73FF`. */
    focus: '#2B73FF'
} as const;

export const BaseColors = {
    dark: {
        ...SharedColors,
        /** Dark Theme ![#141414](https://dummyimage.com/12/141414/141414.png) `#141414`. */
        bgPrimary: '#141414',
        /** Dark Theme ![#212325](https://dummyimage.com/12/212325/212325.png) `#212325`. */
        bgSecondary: '#212325',
        /** Dark Theme ![#FFFFFF](https://dummyimage.com/12/212325/212325.png) `#FFFFFF`. */
        bgTertiary: '#FFFFFF',
        /** Dark Theme ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
        primary: '#FFFFFF',
        /** Dark Theme ![#737373](https://dummyimage.com/12/737373/737373.png) `#737373`. */
        secondary: '#737373',
        /** Dark Theme ![#D8D8D8](https://dummyimage.com/12/D8D8D8/D8D8D8.png) `#D8D8D8`. */
        tertiary: '#D8D8D8'
    } as const,
    light: {
        ...SharedColors,
        /** Light Theme ![#F5F5F5](https://dummyimage.com/12/F5F5F5/F5F5F5.png) `#F5F5F5`. */
        bgPrimary: '#F5F5F5',
        /** Light Theme ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
        bgSecondary: '#FFFFFF',
        /** Dark Theme ![#212325](https://dummyimage.com/12/212325/212325.png) `#212325`. */
        bgTertiary: '#212325',
        /** Light Theme ![#212325](https://dummyimage.com/12/212325/212325.png) `#212325`. */
        primary: '#212325',
        /** Light Theme ![#7a7b7c](https://dummyimage.com/12/7a7b7c/7a7b7c.png) `#7a7b7c`. */
        secondary: '#7a7b7c',
        /** Dark Theme ![#D8D8D8](https://dummyimage.com/12/D8D8D8/D8D8D8.png) `#D8D8D8`. */
        tertiary: '#D8D8D8'
    } as const
} as const;

export const DerivedColors = {
    dark: {
        primary5: darken(BaseColors.dark.primary, 95),
        primary35: darken(BaseColors.dark.primary, 65),
        primary75: darken(BaseColors.dark.primary, 35),
        primary80: darken(BaseColors.dark.primary, 20)
    } as const,
    light: {
        primary5: lighten(BaseColors.light.primary, 95),
        primary35: lighten(BaseColors.light.primary, 65),
        primary75: lighten(BaseColors.light.primary, 35),
        primary80: lighten(BaseColors.light.primary, 20)
    } as const
} as const;

const BoxShadows = {
    /** The default dropshadow for Popovers. */
    popOverShadow: '0px 0px 10px 5px rgba(25, 38, 48, 0.05)'
} as const;

export type BaseColorsType = GetThemeType<typeof BaseColors>;
export const {
    globalCss,
    shadows,
    themeColors,
    themes
} = generateThemes({
    baseColors: BaseColors,
    defaultTheme: 'light',
    derivedColors: DerivedColors,
    shadows: BoxShadows
});